<template>
    <div>
        <div class="content-box">
            <p>确认要去除广告描述、推广产品名称、广告品牌描述中的特殊字符吗，去除后只保留文字、数字、字母。</p>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">确认</el-button>
        </p>
    </div>
</template>

<!-- 小米批量 去除特殊字符弹框-->
<script>

import API from '@/api/marketManage/miBatch.js';
export default {
    name: "resultModal",
    props:['cbs', 'id'],
    data(){
        return {
            formLoading:false,
            formItem:{
                group:'',
            },
            rules:{

            },
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.fetchDel()
        },
        hideModal(){
            this.$emit('close');
        },
        fetchDel() {
            API.postDelSpecialCharacter({task_id:this.id}).then(res=>{
                this.cbs.onSubmit()
            },err=>{
                this.$message.error(err.info)
            })
        }
    }
}
</script>

<style scoped>

</style>
